module.exports = __webpack_public_path__ + "img/layout-grid-01.f50e6076.svg";